import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import SubmitPage from "./pages/SubmitDocument";

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const Page404 = lazy(() => import("./pages/404"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const VerifyCode = lazy(() => import("./pages/VerifyCode"));

function App() {
  return (
    <>
      <Router>
        <AccessibleNavigationAnnouncer />
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/create-account" component={CreateAccount} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/reset-password" component={ResetPassword} />
          <Route path="/verify-code" component={VerifyCode} />
          <Route path="/submit/:id" component={SubmitPage} />

          <ProtectedRoute path="/app" component={Layout} />

          <Redirect exact from="/" to="/login" />
          <Route component={Page404} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
